// import ListarPerfis from './views/ListarPerfis/ListarPerfis'
import ListarUsuarios from './views/ListarUsuarios/ListarUsuarios'
import ImportarBeneficiarios from './views/ImportarBeneficiarios/ImportarBeneficiarios'
import ConsultarEmpresa from './views/ConsultarEmpresa/ConsultarEmpresa.vue'
import HistoricoImportacao from './views/HistoricoImportacao/HistoricoImportacao.vue'
import HistoricoBeneficiario from './views/HistoricoBeneficiario/HistoricoBeneficiario.vue'
import HistoricoInativacao from './views/HistoricoInativacao/HistoricoInativacao.vue'
import Relatorio from './views/Relatorio/Relatorio.vue'
import MasterPageContent from "./MasterPageContent.vue";
import CorrigirErrosInesperados from "./views/CorrigirErrosInesperados/CorrigirErrosInesperados";
import Configuracoes from "./views/Configuracoes/Configuracoes.vue";

const routes = [
	{
		name: "Importar Beneficiários",
		path: "importar-beneficiarios",
		component: ImportarBeneficiarios,
	},
	// {
	// 	name: "Listagem de Perfis",
	// 	path: "listar-perfis",
	// 	component: ListarPerfis,
	// },
	{
		name: "Corrigir Erros Inesperados",
		path: "corrigir-erros-inesperados",
		component: CorrigirErrosInesperados,
	},
	{
		name: "Listagem de Usuários",
		path: "listar-usuarios",
		component: ListarUsuarios,
	},
	{
		name: "Configurações",
		path: "configuracoes",
		component: Configuracoes,
	},
	{
		name: "Consultar Empresa",
		path: "consultar-empresa",
		component: ConsultarEmpresa,
	},
	{
		name: "Histórico de carga",
		path: "historico-importacao",
		component: HistoricoImportacao,
	},
	{
		name: "Histórico de inativação",
		path: "historico-inativacao",
		component: HistoricoInativacao,
	},
	{
		name: "Relatório de Utilização",
		path: "relatorio",
		component: Relatorio,
	},
	{
		name: "Beneficiários",
		path: "historico-beneficiario",
		component: HistoricoBeneficiario,
	},
	{
		name: "Master Page",
		path: "",
		component: MasterPageContent,
	},
];

export default routes;